<div cdkDropListGroup class="list_group">
  <div class="list">
    <h2 class="title_list" appChangeColorTheme attribute="bgc">Articles non prioritaires</h2>

    <div cdkDropList [cdkDropListData]="offersNoPriority" class="list_content" (cdkDropListDropped)="drop($event)"
      id="offersNoPriority">
      <div class="no_offer_priority" *ngIf="!getOffersNoPriority(offersNoPriority)?.length">
        <!-- <p>{{userConnected.role === 'admin' ? 'Il n\' y a aucune offre' : 'Vous n\'avez aucune offre'}}</p> -->
        <p>{{userConnected.role === 'admin' ? 'Il n\' y a aucun article' : 'Vous n\'avez aucun article'}}</p>

      </div>
      <div class="list_item" *ngFor="let item of getOffersNoPriority(offersNoPriority)" cdkDrag
        (cdkDragStarted)="changeDragOffer(item, $event)">
        {{item.offerName}}
        <app-offer-preview-drag-drop *cdkDragPreview [offer]="item" cdkDrag></app-offer-preview-drag-drop>
      </div>
    </div>
  </div>

  <div class="list">
    <div class="title_list" appChangeColorTheme attribute="bgc">
      <h2>Articles prioritaires</h2>
      <p>{{clubSelected?.priorities}}/{{clubSelected?.limitPriorities}} articles prioritaires</p>
    </div>
    <div cdkDropList [cdkDropListData]="offersPriority" class="list_content" (cdkDropListDropped)="drop($event)"
      id="offersPriority">
      <p *ngIf="!offersPriority?.length">Glissez ici les articles pour les rendre prioritaires</p>
      <div class="list_item" *ngFor="let item of offersPriority" cdkDrag>
        {{item.offerName}}
        <app-offer-preview-drag-drop *cdkDragPreview [offer]="item"></app-offer-preview-drag-drop>
      </div>
    </div>
  </div>
</div>
